import { render, staticRenderFns } from "./AdminAcceptedPurchaseOfferFailDialog.vue?vue&type=template&id=7bb80adc&scoped=true&"
import script from "./AdminAcceptedPurchaseOfferFailDialog.vue?vue&type=script&lang=js&"
export * from "./AdminAcceptedPurchaseOfferFailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb80adc",
  null
  
)

export default component.exports